export const VENDOR_TYPES = [
  { value: "book", label: "Book supplier" },
  { value: "uniform", label: "Uniform supplier" },
];

export const vendorTypeLabel = (value) =>
  VENDOR_TYPES.find((t) => t.value === value)?.label || "Book supplier";
